import { gql } from 'graphql-request';

export const getBulkEditAssetsQuery = gql`
  query GetBulkEditAssets($assetIds: [String!], $limit: Int!) {
    assetsPaged(filters: { ids: $assetIds }, limit: $limit) {
      items {
        id
        name
        description
        tags
        owners
        ... on TableAsset {
          sourceName
        }
      }
    }
  }
`;
